import React from 'react'
import ComingSoonScanMeHeader from './ComingSoonScanMeHeader';
import { Button, Container, Grid, createTheme, ThemeProvider, Typography } from "@mui/material";
import travelImage from "../../assets/images/scanMe/main_travel_image.png"



const ComingSoon = () => {

    const theme = createTheme({
        typography: {
            fontFamily: 'Poppins, sans-serif',
        }
    })

    return (
        <>
            <ThemeProvider theme={theme}>
                <ComingSoonScanMeHeader />
                <Container className="stepper-container">
                    <Grid container justifyContent="center" alignItems="center">
                        <Container>
                            <Grid container justifyContent="center" spacing={2} style={{ marginTop: '100px' }}>
                                <Grid item xs={12} sm={10} md={8} lg={8}>
                                    <Grid container justifyContent="center">
                                        <img
                                            className="img-fluid for-light"
                                            src={travelImage}
                                            alt="scanMePage"
                                            style={{ borderRadius: '0px 40px 0px 40px', width: '100%', maxWidth: '550px' }}
                                        />
                                    </Grid>
                                    <Grid container className="mt-3" justifyContent="center" alignItems="center">
                                        <Grid item xs={12}>
                                            <Typography variant="body1" style={{ fontWeight: '275', fontSize: '14px', textAlign: 'center' }}>
                                                We'll be live soon, Stay tuned for something exciting!
                                            </Typography>
                                        </Grid>
                                    </Grid>

                                </Grid>
                            </Grid>
                        </Container>
                    </Grid>

                </Container>
            </ThemeProvider>
        </>
    )
}

export default ComingSoon